import React from "react";
import { CalDate } from "../../../utilities/functions";

const localDateCell = ({ row }) => {
  return <div>{row.date ? CalDate(row.date) : ""}</div>;
};

export default localDateCell;
